import React from 'react';
import { whyUsContent } from '../data/mock';

const WhyUsSection = () => {
  return (
    <section id="why-us" className="section section-dark section-padding">
      <div className="container-custom">
        {/* Header */}
        <div className="mb-16">
          <div className="gold-line mb-6" />
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold mb-4">
            {whyUsContent.title}
          </h2>
          <p 
            className="text-xl max-w-2xl"
            style={{ color: 'var(--text-secondary)' }}
          >
            {whyUsContent.subtitle}
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {whyUsContent.reasons.map((reason, index) => (
            <div 
              key={reason.id}
              className="why-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <span 
                className="text-sm font-medium tracking-wider uppercase mb-3 block"
                style={{ color: 'var(--accent-gold)' }}
              >
                0{reason.id}
              </span>
              <h3 
                className="text-xl md:text-2xl font-semibold mb-3"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                {reason.title}
              </h3>
              <p 
                className="text-base"
                style={{ 
                  color: 'var(--text-secondary)',
                  lineHeight: '1.7'
                }}
              >
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
